import PagingList from './PagingList'

export default PagingList
